export default "__VITE_ASSET__CafFED_V__"